/* El nombre del nuevo contacto legal, para las pantallas.
 *
 *  Aquí vivía además un generador que FABRICABA un PDF con el membrete de
 *  la organización, la fecha y el nombre del nuevo contacto, y lo servía
 *  cuando el Admin ETC pulsaba «Ver doc» o «Descargar». Nació para que la
 *  demostración tuviera algo que enseñar, pero se veía exactamente igual
 *  hubiera adjuntado el socio una carta o no: un acta con pinta de real
 *  que nadie había firmado. Ahora la carta se guarda de verdad (ver
 *  server/src/routes/requests.ts) y esto se borró para que no quede
 *  ninguna vía de enseñar un documento inventado. */
import type { LegalRequest } from '@/types';

export const legalNewName = (r: LegalRequest) => `${r.first} ${r.last}`.trim();
